
import { openModal } from "../../../../state/ModalSlice/ModalSlice"
import { useAppDispatch } from "../../../../state/state"
import { PageName } from "../../../../enums.ts";
import { styled } from '@mui/material/styles';
import Switch, { SwitchProps } from '@mui/material/Switch';

import { useState } from "react"
import OffersContainer from "./Components/OffersContainer"
import EventssContainer from "./Components/EventsContainer"
import AccessControl from "../../Components/AccessControl.tsx";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#2563eb', // Your cc_brand color
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));

export default function OffersEventsPage() {

  const dispatch = useAppDispatch()
  const [showInactiveOffers, setShowInactiveOffers] = useState(false)
  const [showPastEvents, setShowPastEvents] = useState(false)

  function onClickAddOffers() {
    dispatch(openModal("AddOfferModalOpen"))
  }
  function onClickAddEvents() {
    dispatch(openModal("AddEventsModalOpen"))
  }



  return (
    <AccessControl pageName={PageName.Events} >
      <div className="p-6">
        <div className="flex justify-between items-center gap-4 mb-6">
          <div className="">
            <p className="text-lg">Here is an overview of all your events and offers</p></div>
          <div className="flex items-center gap-4">
            <button onClick={onClickAddOffers} className="bg-white font-semibold text-sm text-cc_brand border border-cc_brand hover:bg-cc_brand hover:text-white px-6 py-1.5 rounded-md">Create Offer</button>
            <button onClick={onClickAddEvents} className="bg-white font-semibold text-sm text-cc_brand border border-cc_brand hover:bg-cc_brand hover:text-white px-6 py-1.5 rounded-md">Create Event</button>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-6">
          {/* Active Offers Section */}
          <div className="bg-white rounded-lg shadow p-4 border-[1px] border-gray-300 min-h-[30rem] ">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold">Active Offers</h2>
              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-600">Show Inactive Offers</span>
                <AntSwitch
                  checked={showInactiveOffers}
                  onChange={(e) => setShowInactiveOffers(e.target.checked)}
                  inputProps={{ 'aria-label': 'show inactive offers' }}
                />
              </div>
            </div>
            <OffersContainer showAllOffers={showInactiveOffers} />
          </div>


          {/* Upcoming Events Section */}
          <div className="bg-white rounded-lg shadow p-4 border-[1px] border-gray-300  min-h-[30rem] ">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold">Upcoming Events</h2>
              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-600">Show Past Events</span>
                <AntSwitch
                  checked={showPastEvents}
                  onChange={(e) => setShowPastEvents(e.target.checked)}
                  inputProps={{ 'aria-label': 'show past events' }}
                />
              </div>
            </div>
            <EventssContainer showAllEvents={showPastEvents} />
          </div>
        </div >
      </div>
    </AccessControl>
  )
}